// libs
import React, { memo } from 'react';

interface ShopFilledProps {
  width?: number;
  height?: number;
  fill?: string;
  fillOpacity?: string;
  className?: string;
}

function ShopFilled({
  width = 24,
  height = 24,
  fill = '#001325',
  fillOpacity = '0.64',
  className = '',
}: ShopFilledProps) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <g opacity={fillOpacity}>
        <path
          d="M17 2.87014L18.27 5.14014C18.2999 5.19435 18.3414 5.24128 18.3915 5.27759C18.4417 5.31389 18.4992 5.33866 18.56 5.35014L21.08 5.88014C21.1147 5.88697 21.147 5.90288 21.1735 5.92624C21.2 5.9496 21.2199 5.97958 21.2311 6.01311C21.2423 6.04665 21.2444 6.08256 21.2372 6.11717C21.2299 6.15178 21.2137 6.18385 21.19 6.21014L19.48 8.15014C19.4358 8.19592 19.4028 8.25139 19.3837 8.31215C19.3646 8.3729 19.3599 8.43726 19.37 8.50014L19.65 11.1001C19.653 11.1347 19.6469 11.1695 19.6323 11.201C19.6178 11.2325 19.5953 11.2597 19.567 11.2799C19.5388 11.3001 19.5057 11.3126 19.4712 11.3161C19.4367 11.3197 19.4018 11.3141 19.37 11.3001L17 10.2301C16.9433 10.2054 16.882 10.1926 16.82 10.1926C16.7581 10.1926 16.6968 10.2054 16.64 10.2301L14.31 11.3101C14.2779 11.3266 14.2419 11.3341 14.2058 11.3317C14.1698 11.3294 14.135 11.3173 14.1053 11.2968C14.0755 11.2763 14.0519 11.2481 14.0369 11.2152C14.0219 11.1824 14.0161 11.146 14.02 11.1101L14.3 8.51014C14.308 8.44732 14.3022 8.38353 14.2833 8.32312C14.2643 8.26272 14.2325 8.20712 14.19 8.16014L12.48 6.22013C12.4564 6.19385 12.4401 6.16178 12.4329 6.12717C12.4257 6.09256 12.4278 6.05665 12.439 6.02311C12.4502 5.98958 12.47 5.9596 12.4966 5.93624C12.5231 5.91288 12.5554 5.89697 12.59 5.89014L15.11 5.36014C15.1708 5.34512 15.2279 5.31787 15.2777 5.28004C15.3276 5.24221 15.3692 5.19461 15.4 5.14014L16.67 2.87014C16.6897 2.84517 16.7147 2.825 16.7433 2.81112C16.7719 2.79725 16.8033 2.79004 16.835 2.79004C16.8668 2.79004 16.8982 2.79725 16.9267 2.81112C16.9553 2.825 16.9804 2.84517 17 2.87014Z"
          fill={fill}
        />
        <path
          d="M9.58995 11.0001H6.65995C6.14648 11.0015 5.63778 10.9016 5.1629 10.7063C4.68801 10.5111 4.25624 10.2241 3.89223 9.862C3.52822 9.49985 3.23911 9.06955 3.0414 8.59567C2.8437 8.12179 2.74126 7.61361 2.73995 7.10014V7.10014C2.73467 6.58284 2.83183 6.06961 3.02584 5.59004C3.21985 5.11048 3.50686 4.67405 3.87033 4.30593C4.23381 3.93781 4.66655 3.64528 5.14361 3.44519C5.62068 3.24511 6.13263 3.14143 6.64995 3.14014V3.14014C7.68695 3.14014 8.68147 3.55208 9.41474 4.28535C10.148 5.01862 10.56 6.01314 10.56 7.05014V10.0001C10.5601 10.2602 10.4588 10.5101 10.2777 10.6968C10.0966 10.8835 9.84993 10.9923 9.58995 11.0001V11.0001Z"
          fill={fill}
        />
        <path
          d="M10.58 14.4102V17.3202C10.58 18.3554 10.1694 19.3484 9.43833 20.0814C8.70723 20.8144 7.71527 21.2275 6.68001 21.2302V21.2302C5.64382 21.2302 4.64977 20.8199 3.9152 20.0891C3.18063 19.3583 2.7653 18.3663 2.76001 17.3302V17.3302C2.76001 16.2922 3.17163 15.2967 3.90461 14.5618C4.63759 13.827 5.63209 13.4128 6.67001 13.4102H9.58001C9.84523 13.4102 10.0996 13.5155 10.2871 13.703C10.4747 13.8906 10.58 14.1449 10.58 14.4102Z"
          fill={fill}
        />
        <path
          d="M12.9301 14.4102V17.3202C12.9327 18.3563 13.3455 19.3493 14.0782 20.082C14.8109 20.8147 15.8039 21.2275 16.8401 21.2302V21.2302C17.3535 21.2315 17.8622 21.1316 18.3371 20.9364C18.812 20.7411 19.2438 20.4542 19.6078 20.092C19.9718 19.7299 20.2609 19.2996 20.4586 18.8257C20.6563 18.3518 20.7587 17.8436 20.7601 17.3302V17.3302C20.7601 16.294 20.3498 15.2999 19.619 14.5653C18.8882 13.8308 17.8962 13.4154 16.8601 13.4102H13.9301C13.6648 13.4102 13.4105 13.5155 13.2229 13.703C13.0354 13.8906 12.9301 14.1449 12.9301 14.4102Z"
          fill={fill}
        />
      </g>
    </svg>
  );
}

export default memo(ShopFilled);
